import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { CommonDialogComponent } from './dialogueBoxes/common/common-dialog.component';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { LogoutDialogComponent } from './dialogueBoxes/logout/logout-dialog.component';
import { LoaderComponent } from './loader/components/loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderService } from './loader/loader.service';
import { ChatpanelComponent } from './common/chatpanel/chatpanel.component';
import { HeaderComponent } from './common/header/header.component';
import { SidebarComponent } from './common/sidebar/sidebar.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { TableComponent } from '../common/table/table.component';
import { ListingTableComponent } from '../common/Listingtable/Listingtable.component';
import { AddTouchesComponent } from '../common/addtouches/addtouches.component';
import { AddTouchesTypeComponent } from '../common/addtouchestype/addtouchestype.component';
import { clickableColumns } from '../common/clickableColumns';
import { editColumnEventDetails } from '../common/editColumnEventDetails';
import { ExcelServicesService } from '../common/excel-services.service';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConvertLocalDate } from '../common/Pipes/ConvertLocalDate';
import { ConvertLocalDateOnly } from '../common/Pipes/ConvertLocalDateOnly';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatSortModule } from '@angular/material/sort';
import { ErrorVerificationComponent } from './errorVerifcation/components/errorVerification/error-verification.component';
import { OnlynumberDirective } from '../common/reusableclassesAndFunctions/number-d.directive';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ThemingService } from './../../theming.service';
import { MatCardModule } from '@angular/material/card';
import { MatBadgeModule } from '@angular/material/badge';
import { ContactlistComponent } from './common/contactlist/contactlist.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkTableModule } from '@angular/cdk/table';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxMatDrpModule } from 'ngx-mat-daterange-picker';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { FileModelVM } from 'src/app/viewModels/core/core-vm';
import { AssociateCoreComponent } from 'src/app/middleware/common/associate-core/associate-core.component';
import { AssociateContactComponent } from 'src/app/middleware/common/associate-contact/associate-contact.component';
import { AssociateCompanyComponent } from 'src/app/middleware/common/associate-company/associate-company.component';
import { PageNotFoundComponent } from 'src/app/middleware/common/pagenotfound/pagenotfound.component';
import { DetailsComponent } from '../common/details/details.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { CreatefolderforFormComponent } from '../common/createfolderforForm/createfolderforForm.component';
import { EditfolderforFormComponent } from '../common/editfolderforForm/editfolderforForm.component';
import { MovetoFileManagerComponent } from '../common/movetoFileManager/movetoFileManager.component';
import { RenameFileManagerComponent } from '../common/renameFileManagerItem/renameFileManager.component';
import { MatTreeModule } from '@angular/material/tree';
import { RequestFileComponent } from '../common/request-File/request-File.component';
import { DayAgoPipe } from '../day-ago-pipe';
import { UserActivationDialogComponent } from './dialogueBoxes/useractivation/useractivation-dialog.component';
import { DocumentViewerComponent } from './common/document-viewer/document-viewer.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { AddMasterTempCategoryComponent } from '../common/addMasterTempCategory/addMasterTempCategory.component';
import { AutoSizeInputModule } from 'ngx-autosize-input';
import { MovetoFormComponent } from '../common/movetoForm/movetoForm.component';
import { AddNewComponent } from '../common/addnew/addnew.component';
import { AddTaskComponent } from '../common/addtask/addtask.component';
// import { TaskDetailsComponent } from '../common/task-details/task-details.component';
import { TaskDetailsComponent } from '../shared/common/task-details/task-details.component';
import { AuthService } from 'src/app/applicationModules/authentication/services/auth/auth.service';
import { PaycheckErrorComponent } from '../common/paycheckError/paycheckError.component';
import { Task3CComponent } from './common/task3c/task3c.component';
import { TaskAssignComponent } from '../shared/common/task-details/task-assign/task-assign.component';
import { TaskAttachCccComponent } from '../shared/common/task-details/task-attach-ccc/task-attach-ccc.component';
import { Task3CTaskListsComponent } from './common/task3c-tasklists/task3c-tasklists.component';
import { MatTabsModule } from '@angular/material/tabs';
import { AddOrgTempCategoryComponent } from '../common/addOrgTempCategory/addOrgTempCategory.component';
import { DocIconsComponent } from './common/doc-icons/doc-icons.component';
import { AddTaskTempCategoryComponent } from '../common/addTaskTempCategory/addTaskTempCategory.component';
import { SendDocumentComponent } from '../common/send-document/send-document.component';
import { BindFieldAIComponent } from '../common/bind-field-ai/bind-field-ai.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FaxFileComponent } from '../common/fax-File/fax-File.component';
import { BindFieldFormsComponent } from '../common/bind-field-forms/bind-field-forms.component';
import { AttachToTaskListComponent } from '../common/attachToTaskList/attachToTaskList.component';
import { ImportForm3CListComponent } from '../common/importForm3C/importForm3C.component';
import { AddOfficeComponent } from '../common/addOffice/addOffice.component';
import { TouchesListComponent } from './common/touches-list/touches-list.component';
import { GroupListingTableComponent } from '../common/group-listing-table/group-listing-table.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { EmailPhoneComponent } from './common/email-phone/email-phone.component';
import { FlowtricsBotComponent } from './common/flowtrics-bot/flowtrics-bot.component';
import { AddToucheStatusTypeComponent } from '../common/addtouchestatustype/addtouchestatustype.component';
import { AiDetailComponent } from './common/ai-detail/ai-detail.component';
import { AiDetailsComponent } from '../common/ai-details/ai-details.component';
import { AddAITempCategoryComponent } from '../common/addAITempCategory/addAITempCategory.component';
import { AddEmailActionComponent } from '../common/addEmailAction/addEmailAction.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { EmailComponent } from './common/email/email.component';
import { AiQuestionComponent } from './common/ai-question/ai-question.component';
import { AddQuestionTempCategoryComponent } from '../common/addQuesTempCategory/addQuesTempCategory.component';
import { EmailFileComponent } from '../common/email-File/email-File.component';
import { OpenHTMLFormComponent } from '../common/openHtmlForm/openHtmlForm.component';
import { SignaturePadModule } from 'ngx-signaturepad';
import { AddEmailForFormComponent } from '../common/addEmailForForm/addEmailForForm.component';
import { SelectFormIconComponent } from '../common/selectFormIcon/selectFormIcon.component';
import { HtmlReport3cComponent } from './common/htmlReport3c/htmlReport3c.component';
import { AddUrlinFolderComponent } from '../common/addurlinFolder/addurlinFolder.component';
import { CustomInfo3cComponent } from './common/customInfo3c/customInfo3c.component';
import { CustomInfoListComponent } from './common/customInfo-list/customInfo-list.component';
import { AddCustomInfoComponent } from '../common/addCustomInfo/addCustomInfo.component';
import { AddCustomInfoTypeComponent } from '../common/addcustomInfotype/addcustomInfotype.component';
import { AddCustomInfoStatusTypeComponent } from '../common/addcustominfostatustype/addcustominfostatustype.component';
import { AddFormReports3CMapComponent } from '../common/FormReports3CMap/FormReports3CMap.component';
import { Add3cforPccComponent } from '../common/add3cforPcc/add3cforPcc.component';
import { SelectPromptTemplateComponent } from '../common/selectPromptTemplate/selectPromptTemplate.component';
import { SelectFieldTemplateComponent } from '../common/selectFieldTemplate/selectFieldTemplate.component';
import { ImportMyDriveListComponent } from '../common/importMyDrive/importMyDrive.component';
import { AddSelectParticipantComponent } from '../common/addselectParticipant/addselectParticipant.component';
import { Add3ctypeformComponent } from '../common/add3ctypeform/add3ctypeform.component';
import { AddSignatureComponent } from '../common/addSignature/addSignature.component';
import { AttachAIAutomationTemplateComponent } from '../common/attachAIAutomationTemplate/attachAIAutomationTemplate.component';
import { DocumentViewersComponent } from '../common/document-viewers/document-viewers.component';
import { AutomationErrorComponent } from '../common/automationError/automationError.component';


@NgModule({
  declarations: [AiQuestionComponent, CommonDialogComponent, LogoutDialogComponent, UserActivationDialogComponent, LoaderComponent, ChatpanelComponent,
    HeaderComponent, SidebarComponent, TableComponent, ListingTableComponent, AddTouchesComponent, AddTouchesTypeComponent, AddMasterTempCategoryComponent,
    AddOrgTempCategoryComponent, BindFieldAIComponent, BindFieldFormsComponent,
    AddNewComponent, CreatefolderforFormComponent, EditfolderforFormComponent,
    DetailsComponent, AssociateCoreComponent, AssociateContactComponent, AssociateCompanyComponent,
    PageNotFoundComponent, ErrorVerificationComponent, ContactlistComponent, MovetoFileManagerComponent,
    RenameFileManagerComponent, RequestFileComponent, DayAgoPipe, DocumentViewerComponent,
    MovetoFormComponent, AddTaskComponent, TaskDetailsComponent, PaycheckErrorComponent, Task3CComponent,
    TaskAssignComponent, TaskAttachCccComponent, Task3CTaskListsComponent, DocIconsComponent,
    AddTaskTempCategoryComponent, SendDocumentComponent, FaxFileComponent, AttachToTaskListComponent,
    ImportForm3CListComponent,
    AddOfficeComponent,
    TouchesListComponent,
    GroupListingTableComponent,
    EmailPhoneComponent,
    FlowtricsBotComponent,
    AddToucheStatusTypeComponent,
    AiDetailsComponent,
    AddAITempCategoryComponent,
    AddEmailActionComponent,
    EmailComponent,
    AddQuestionTempCategoryComponent,
    EmailFileComponent,
    OpenHTMLFormComponent,
    AddEmailForFormComponent,
    SelectFormIconComponent,
    HtmlReport3cComponent, 
    AddUrlinFolderComponent,
    AddFormReports3CMapComponent,
    CustomInfo3cComponent,
    CustomInfoListComponent,
    AddCustomInfoComponent,
    AddCustomInfoTypeComponent,
    AddCustomInfoStatusTypeComponent,
    Add3cforPccComponent,
    Add3ctypeformComponent,
    SelectPromptTemplateComponent,
    SelectFieldTemplateComponent,
    ImportMyDriveListComponent,
    AddSelectParticipantComponent,
    AddSignatureComponent,
    AttachAIAutomationTemplateComponent,
    DocumentViewersComponent,
    AutomationErrorComponent
  ],
  imports: [
    ClipboardModule,
    CommonModule,
    DragDropModule,
    CdkTableModule,
    MatDialogModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    NgxDaterangepickerMd,
    MatButtonModule,
    MatRadioModule,
    MatChipsModule,
    HttpClientModule,
    RouterModule,
    MatPaginatorModule,
    MatTableModule,
    MatTooltipModule,
    FlexLayoutModule,
    MatSortModule,
    MatAutocompleteModule,
    MatCardModule,
    MatBadgeModule,
    MatMenuModule,
    NgxMatDrpModule,
    ScrollingModule,
    MatExpansionModule,
    NgxMaterialTimepickerModule,
    MatTreeModule,
    NgxDocViewerModule,
    AutoSizeInputModule,
    MatTabsModule,
    NgSelectModule,
    CKEditorModule,
    SignaturePadModule
  ],
  entryComponents: [
    CommonDialogComponent
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {}
    },
    LoaderService,
    ExcelServicesService,
    clickableColumns,
    editColumnEventDetails,
    ConvertLocalDate,
    ConvertLocalDateOnly,
    ThemingService,
    FileModelVM,
    DatePipe,
  ],
  exports: [
    AiQuestionComponent,
    EmailComponent,
    EmailPhoneComponent,
    LoaderComponent,
    ChatpanelComponent,
    HeaderComponent,
    SidebarComponent,
    TableComponent,
    ListingTableComponent,
    GroupListingTableComponent,
    AddTouchesComponent,
    AddTouchesTypeComponent,
    AddMasterTempCategoryComponent,
    AddOrgTempCategoryComponent,
    CreatefolderforFormComponent,
    EditfolderforFormComponent,
    AddNewComponent,
    BindFieldAIComponent,
    BindFieldFormsComponent,
    Task3CComponent,
    TaskAssignComponent,
    TaskAttachCccComponent,
    Task3CTaskListsComponent,
    AddTaskComponent,
    TaskDetailsComponent,
    DetailsComponent, 
    MatSortModule,
    MatPaginatorModule,
    ContactlistComponent,
    AssociateCoreComponent,
    AssociateContactComponent,
    AssociateCompanyComponent,
    MovetoFileManagerComponent,
    MovetoFormComponent,
    PageNotFoundComponent,
    RequestFileComponent,
    DocIconsComponent,
    AddTaskTempCategoryComponent,
    AddQuestionTempCategoryComponent,
    SendDocumentComponent,
    FaxFileComponent,
    AttachToTaskListComponent,
    ImportForm3CListComponent,
    TouchesListComponent,
    FlowtricsBotComponent,
    AiDetailsComponent,
    AddAITempCategoryComponent,
    AddEmailActionComponent,
    EmailFileComponent,
    OpenHTMLFormComponent,
    AddEmailForFormComponent,
    SelectFormIconComponent,
    HtmlReport3cComponent,   
    AddUrlinFolderComponent,
    AddFormReports3CMapComponent,
    CustomInfo3cComponent,
    CustomInfoListComponent,
    AddCustomInfoComponent,
    AddCustomInfoTypeComponent,
    AddCustomInfoStatusTypeComponent,
    Add3cforPccComponent,
    SelectPromptTemplateComponent,
    SelectFieldTemplateComponent,
    ImportMyDriveListComponent,
    AddSelectParticipantComponent,
    AddSignatureComponent,
    DocumentViewersComponent
  ]
})
export class SharedModule { }
